// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

import stringIncludes from 'core-js/features/string/virtual/includes';
import stringPadStart from 'core-js/features/string/virtual/pad-start';
import stringRepeat from 'core-js/features/string/virtual/repeat';
import stringStartsWith from 'core-js/features/string/virtual/starts-with';

String.prototype.includes = String.prototype.includes || stringIncludes;
String.prototype.padStart = String.prototype.padStart || stringPadStart;
String.prototype.repeat = String.prototype.repeat || stringRepeat;
String.prototype.startsWith = String.prototype.startsWith || stringStartsWith;
